import { UPDATE_FILTERS } from "./types";

export const menuFilterReducer = (store=[],action)=>{
        if(action.type == UPDATE_FILTERS)  return action.payload
        else  return store;
}